import { pagination_params } from '../../shared/utils/pagination_params';

export const getParamsUrl = (params) => {
  if (!params) return '';
  let path = '';
  path = pagination_params(params);
  params.FechaDesde && (path = `${path !== '' ? `${path}&` : ''}FechaDesde=${params.FechaDesde}`);
  params.FechaHasta &&
    (path = `${path !== '' ? `${path}&` : ''}FechaHasta=${setHoursEndOfDate(params.FechaHasta)}`);
  params.EstadoSolicitud &&
    params.EstadoSolicitud.Codigo &&
    (path = `${path !== '' ? `${path}&` : ''}CodigoEstado=${params.EstadoSolicitud.Codigo}`);
  if (params.CodigoUsuarioCreacion) {
    const codigos = Array.isArray(params.CodigoUsuarioCreacion)
      ? params.CodigoUsuarioCreacion
      : [params.CodigoUsuarioCreacion];
    codigos.forEach((codigo) => {
      path = `${path !== '' ? `${path}&` : ''}CodigoUsuarioCreacion=${codigo}`;
    });
  }
  params.Cliente && (path = `${path !== '' ? `${path}&` : ''}Cliente=${params.Cliente}`);
  params.Referencia && (path = `${path !== '' ? `${path}&` : ''}Referencia=${params.Referencia}`);
  params.FechaEstadoDesde &&
    (path = `${path !== '' ? `${path}&` : ''}FechaEstadoDesde=${params.FechaEstadoDesde}`);
  params.FechaEstadoHasta &&
    (path = `${path !== '' ? `${path}&` : ''}FechaEstadoHasta=${setHoursEndOfDate(params.FechaEstadoHasta)}`);
  params.CodigoEspecificacionTecnica &&
    (path = `${path !== '' ? `${path}&` : ''}CodigoEspecificacionTecnica=${encodeURIComponent(params.CodigoEspecificacionTecnica)}`);
  params.Codigo &&
    (path = `${path !== '' ? `${path}&` : ''}Codigo=${encodeURIComponent(params.Codigo)}`);
  params.AllRequest && (path = `${path !== '' ? `${path}&` : ''}AllRequest=${params.AllRequest}`);
  if (params.ElementoTipo && Array.isArray(params.ElementoTipo)) {
    const codigosElementoTipo = params.ElementoTipo.map((tipo) => tipo.Codigo);
    codigosElementoTipo.forEach((codigo) => {
      path = `${path !== '' ? `${path}&` : ''}CodigoElementoTipo=${encodeURIComponent(codigo)}`;
    });
  }
  params.CodigoEquivalente &&
    (path = `${path !== '' ? `${path}&` : ''}CodigoEquivalente=${params.CodigoEquivalente}`);
  params.CodigoAdicional &&
    (path = `${path !== '' ? `${path}&` : ''}CodigoAdicional=${params.CodigoAdicional}`);
  params.DescripcionComercial &&
    (path = `${path !== '' ? `${path}&` : ''}DescripcionComercial=${encodeURIComponent(params.DescripcionComercial)}`);
  params.CodigoUsabilidad &&
    (path = `${path !== '' ? `${path}&` : ''}CodigoUsabilidad=${params.CodigoUsabilidad}`);
  params.Suaje &&
    (path = `${path !== '' ? `${path}&` : ''}Suaje=${encodeURIComponent(params.Suaje)}`);
  if (params.Procesos && Array.isArray(params.Procesos) && params.Procesos.length > 0) {
    const codigosProcesos = params.Procesos.map((p) => p.Codigo || p);
    const stringProcesos = codigosProcesos.join(',');
    path = `${path !== '' ? `${path}&` : ''}Procesos=${encodeURIComponent(stringProcesos)}`;
  }
  return path;
};

const setHoursEndOfDate = (fecha) => {
  if (fecha) {
    const fechaSeleccionada = new Date(fecha);
    fechaSeleccionada.setHours(23, 59, 59, 999);
    return fechaSeleccionada;
  }
  return fecha;
};
